<template>
    <div class="title-bar">
        <div class="left-line"></div>
        <div class="title-name">{{titleName}}</div>
    </div>
</template>

<script>
    export default {
        props:{
            titleName:{
                type: String,
                default:()=> ""
            }
        },
        data() {
            return {

            }
        }
    }
</script>

<style lang="less" scoped>
.title-bar {
    display: flex;
    justify-content: flex-start;
    // margin:20px;
    margin: 20px 20px 20px 0;
}
.left-line {
    width: 6px;
    height: 20px;
    background: #25A1E3;
    border-radius: 0px 3px 3px 0px;
    margin-right: 10px;
}
.title-name {
    font-size: 16px;
    font-weight: bold;
    color: #666666;
}
</style>